/* global globalThis */
/**
 * 环境变量（构建时注入）。
 *
 * 必须使用字面量 `process.env.VITE_XXX`（不要用 process.env[key]），
 * 否则 Webpack DefinePlugin / Vite define 无法在打包时替换，浏览器里会拿到空字符串，
 * axios 会退化为请求当前页面源（如 me.test.boserver.cn:8090）。
 */
function s(v) {
    if (v == null || v === '') {
        return '';
    }
    return String(v);
}

function deployment(key, fallback) {
    const config = typeof globalThis !== 'undefined' ? globalThis.__AUTOMACHINE_DEPLOYMENT__ : null;
    return s(config && Object.prototype.hasOwnProperty.call(config, key) ? config[key] : fallback);
}

export const env = {
    get SITE_TITLE() {
        return s(process.env.VITE_SITE_TITLE);
    },
    get SITE_ICP_NUMBER() {
        return s(process.env.VITE_SITE_ICP_NUMBER);
    },
    get BASE_API() {
        return deployment('BASE_API', process.env.VITE_BASE_API);
    },
    get BASE_UPLOAD() {
        return deployment('BASE_UPLOAD', process.env.VITE_BASE_UPLOAD);
    },
    get BASE_VUE() {
        return deployment('BASE_VUE', process.env.VITE_BASE_VUE);
    },
    get BASE_MQTT() {
        return deployment('BASE_MQTT', process.env.VITE_BASE_MQTT);
    },
    get BASE_OSS() {
        return deployment('BASE_OSS', process.env.VITE_BASE_OSS);
    },
    get BASE_NAME_CN() {
        return s(process.env.VITE_BASE_NAME_CN);
    },
    get BASE_NAME_ZH_TW() {
        return s(process.env.VITE_BASE_NAME_ZH_TW);
    },
    get BASE_NAME_EN() {
        return s(process.env.VITE_BASE_NAME_EN);
    },
    get BASE_NAME_MA() {
        return s(process.env.VITE_BASE_NAME_MA);
    },
    get BASE_NAME_RU() {
        return s(process.env.VITE_BASE_NAME_RU);
    },
    get BASE_NAME_KO() {
        return s(process.env.VITE_BASE_NAME_KO);
    },
    get BASE_NAME_PT() {
        return s(process.env.VITE_BASE_NAME_PT);
    },
    get BASE_NAME_ES() {
        return s(process.env.VITE_BASE_NAME_ES);
    },
    get BASE_NAME_VN() {
        return s(process.env.VITE_BASE_NAME_VN);
    },
    get BASE_NAME_JA() {
        return s(process.env.VITE_BASE_NAME_JA);
    },
    get BASE_NAME_DE() {
        return s(process.env.VITE_BASE_NAME_DE);
    },
    get BASE_NAME_FR() {
        return s(process.env.VITE_BASE_NAME_FR);
    },
    get BASE_NAME_TH() {
        return s(process.env.VITE_BASE_NAME_TH);
    },
    get BASE_LOGO() {
        return s(process.env.VITE_BASE_LOGO);
    },
    /** 未上传分类图时优先使用；与 defaultCategoryPic 搭配 */
    get BASE_PRODUCT_PIC() {
        return s(process.env.VITE_BASE_PRODUCT_PIC);
    },
    /** 分类默认图、导入商品 saveProduct 的 cpicture：VITE_BASE_PRODUCT_PIC 非空则用之，否则 VITE_BASE_LOGO */
    get defaultCategoryPic() {
        const p = this.BASE_PRODUCT_PIC;
        return p !== '' ? p : this.BASE_LOGO;
    },
    get BASE_ICO() {
        return s(process.env.VITE_BASE_ICO);
    },
    get I18N_LOCALE() {
        const v = process.env.VITE_I18N_LOCALE;
        return v != null && v !== '' ? String(v) : 'en';
    },
    get I18N_FALLBACK_LOCALE() {
        const v = process.env.VITE_I18N_FALLBACK_LOCALE;
        return v != null && v !== '' ? String(v) : 'en';
    },
    /**
     * 可选语言及在界面上的显示顺序，逗号/空格分隔，与 src/locales 下 json 名一致。
     * 留空则使用本地 localeSupport 内默认全量与顺序。
     */
    get I18N_LOCALES() {
        const v = process.env.VITE_I18N_LOCALES;
        return v != null && v !== '' ? String(v) : '';
    },
};
